import React, {useEffect, useState} from "react";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";
import {formattedDate} from "../../../helpers/dateFormater";
import {getAllNews} from "../../../lib/newsApi";

const Article = ({article}) => {
    return <li className={'article_item'}>
        <Link target={'_blank'} rel={'noopener noreferrer'} className={'article_item_wrapper'}  href={article?.source || '#'}>
            {article?.cover?.url && <img className={'article_item_cover'}
                                         src={`${process.env.NEXT_PUBLIC_BLOG_API_URL}${article?.cover?.url?.slice(1)}`}
                                         alt={''}/>}
            {article?.news_categories?.length ?
                <span className={'article_item_category'}>{article.news_categories[0]?.name}</span> : null}
            <h3 className={'article_item_title'}>{article?.title}</h3>
            <span className={'article_item_date'}>{formattedDate(article?.updatedAt)}</span>
        </Link>
    </li>
}

export default function LatestNewsWidget() {

    const {t} = useTranslation();
    const latest_widget = t('common:latest_widget', {}, {returnObjects: true});

    const [posts, setPosts] = useState([]);

    const currentPage = 1; // Default to page 1 if not present
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPosts = async (page) => {
            try {
                const {posts, pagination} = await getAllNews(page, '', '');
                setPosts(posts);
            } catch (error) {
                setError("Error fetching posts.");
                console.error("Error fetching posts:", error);
            } finally {

            }
        };

        fetchPosts(currentPage);

    }, [currentPage]); // Re-fetch when page or search query changes

    return (

        <section className={'news_widget'}>
            <div className={'articles'}>
                <div className="container">
                    <div className={'news_widget_title'}>
                        <h2 className={'widget_title'}>{latest_widget.title}</h2>
                        <Link href={'/latest-news'} className={'widget_cta'}>
                            {latest_widget.cta}
                            <img src={'/img/commons/read_more_btn.png'} alt={'read more'}/>
                        </Link>
                    </div>

                    <ul className={'articles_list'}>
                        {posts?.length ? posts.slice(0, 3).map((post, i) => {
                            return <Article
                                key={post.id}
                                article={post}
                            />

                        }) : <li className={'article_item'}>No Available Posts</li>}
                    </ul>
                </div>
            </div>
        </section>
    );
}
